import {
  BatteryFull,
  DeveloperBoard,
  MobileScreenShareRounded,
  Settings,
  SettingsAccessibility,
  Web,
} from "@mui/icons-material";
import {
  Box,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";

const descCols = [
  {
    heading: "School Management Platform",
    desc: "An intelligent, centralized system to automate attendance, grading, timetables, and academic reporting with complete operational visibility.",
    icon: <BatteryFull />,
  },
  {
    heading: "Parent Engagement App",
    desc: "Real-time communication and updates that strengthen parent-school collaboration and build transparency in academic progress.",
    icon: <Settings />,
  },
  {
    heading: "AI-Powered Tutor",
    desc: "24/7 personalized academic assistance delivering structured explanations, concept clarity, and performance-driven insights.",
    icon: <SettingsAccessibility />,
  },
  {
    heading: "Gamified Learning Engine",
    desc: "Interactive quizzes and achievement systems that boost engagement, improve retention, and drive measurable academic outcomes.",
    icon: <Web />,
  },
  {
    heading: "Unified Communication Hub",
    desc: "Instant notifications, announcements, and structured messaging to streamline collaboration between staff, parents, and students.",
    icon: <MobileScreenShareRounded />,
  },
  {
    heading: "Smart Fee & Billing System",
    desc: "Automated invoicing, payment tracking, and financial transparency powered by secure cloud infrastructure.",
    icon: <DeveloperBoard />,
  },
];

const OurServices = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 0 },
        background:
          "linear-gradient(180deg, #ffffff 0%, #f8fbff 40%, #ffffff 100%)",
      }}
    >
      <Container maxWidth="lg">
        {/* Header */}
        <Box textAlign="center" mb={{ xs: 8, md: 10 }}>
          <Typography
            variant="h2"
            fontWeight={800}
            gutterBottom
            color = "primary"
            sx={{
              lineHeight: 1.2,
              letterSpacing: "-0.5px",
            }}
          >
            Powerful Solutions for Modern Education
          </Typography>

          <Typography
            variant="h6"
            color="text.secondary"
            sx={{
              maxWidth: 800,
              mx: "auto",
              lineHeight: 1.8,
            }}
          >
            MySchoolling combines enterprise-grade school management,
            AI-powered learning tools, and seamless communication systems
            into one intelligent ecosystem.
          </Typography>
        </Box>

        {/* Services Grid */}
        <Grid container spacing={5}>
          {descCols.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box
                sx={{
                  p: 5,
                  borderRadius: 4,
                  height: "100%",
                  background: "#ffffff",
                  border: "1px solid rgba(0,0,0,0.05)",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.04)",
                  transition: "all 0.35s ease",
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,

                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 30px 80px rgba(25,118,210,0.12)",
                    border: "1px solid rgba(25,118,210,0.2)",
                  },
                }}
              >
                {/* Icon */}
                <Box
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:
                      "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                    color: "#ffffff",
                    boxShadow: "0 10px 30px rgba(25,118,210,0.3)",
                  }}
                >
                  {item.icon}
                </Box>

                {/* Title */}
                <Typography variant="h5" fontWeight={700}>
                  {item.heading}
                </Typography>

                {/* Description */}
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ lineHeight: 1.8 }}
                >
                  {item.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default OurServices;